import React, { useEffect } from "react";
import { cn } from "../../utils/cn";

/** @deprecated Use BasicDialog instead. This is kept only to avoid breaking old imports. */

/**
 * Lightweight controlled Dialog
 * Props:
 *  - open: boolean
 *  - onClose: () => void
 *  - title?: string
 *  - children
 *  - footer?: ReactNode (actions)
 */
export default function Dialog({ open, onClose, title, children, footer, className, panelClassName }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className={cn(
        "fixed inset-0 z-[999] grid place-items-center",
        "bg-black/40 backdrop-blur-[1px]"
      )}
      role="dialog"
      aria-modal="true"
      onClick={(e) => {
        if (e.currentTarget === e.target) onClose?.();
      }}
    >
      <div
        className={cn(
          "w-[90vw] max-w-md rounded-card bg-card text-[rgb(var(--afrimed-foreground))] shadow-card",
          "border border-[rgb(var(--afrimed-outline))]",
          panelClassName
        )}
      >
        {title ? (
          <div className="px-5 py-4 border-b border-[rgb(var(--afrimed-outline))] text-[16px] font-medium">
            {title}
          </div>
        ) : null}

        <div className={cn("px-5 py-4", className)}>{children}</div>

        {footer ? (
          <div className="px-5 py-3 border-t border-[rgb(var(--afrimed-outline))] flex justify-end gap-2">
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
}